module.exports = __webpack_public_path__ + "images/login_icon_my_yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login_icon_my_yellow.png
// module id = 877
// module chunks = 121